import React, { useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { useEventContext } from "../../../state/events/context";
import Configuration from "../../common/components/Configuration";
import { getSportConfiguration } from "../../common/config/sport-configurations";
import { useGameContextContext } from "../../../state/game-context/context";
import {
	resolveRuleSetName,
	resolveSettingDefinitions
} from "../../../util/definitions-util";

const EventSettingsPreview = () => {
	const { state: eventState } = useEventContext();
	const { gameConfiguration, customFormData, rulesetDefaults } =
		eventState.currentEventSettings();
	const { sportId } = eventState.currentEvent() || {};
	const { state: gameContextState } = useGameContextContext();
	const ruleSetId = gameContextState.ruleSetId();
	// The crew is about to start a game: this panel is where a definition is
	// worth most, and it is read-only, so nothing can be changed by mistake.
	const definitions = useMemo(
		() => resolveSettingDefinitions(sportId, ruleSetId, gameConfiguration),
		[sportId, ruleSetId, gameConfiguration]
	);

	return (
		<Grid item container>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h5">Event Settings</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Configuration
						configuration={gameConfiguration}
						customFormData={customFormData}
						rulesetDefaults={rulesetDefaults}
						extension={getSportConfiguration(sportId)}
						definitions={definitions}
						ruleSetName={resolveRuleSetName(sportId, ruleSetId)}
						preview
					/>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};

export default EventSettingsPreview;
